"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effects = void 0;
const __1 = require("../../");
const triggers_1 = require("../../triggers");
const DamageEffect = {
    activate(e) {
        if (!e.params.value)
            throw new __1.InvalidEffectParamsError();
        for (const target of e.targets) {
            if (target === __1.TargetTypes.EnemyMonkey)
                e.game.dealMonkeyDamage(e.game.otherPlayer(e.player), e.params.value);
            else
                e.game.dealDamage(target, e.params.value);
        }
    },
};
const BuffEffect = {
    activate(e) {
        for (const target of e.targets) {
            if (target === __1.TargetTypes.EnemyMonkey)
                continue;
            if (e.params.attack)
                e.game.setAttack(target, target.attack + e.params.attack);
            if (e.params.health)
                e.game.setHealth(target, target.health + e.params.health);
        }
    },
};
const BuffForTurnEffect = {
    activate(e) {
        BuffEffect.activate(e);
        const handler = ({ player }) => {
            if (player.user.waxAddress === e.player.user.waxAddress) {
                e.params.attack *= -1;
                BuffEffect.activate(e);
                e.game.eventEmitter.off(triggers_1.Triggers.TurnEndTrigger, handler);
            }
        };
        e.game.eventEmitter.on(triggers_1.Triggers.TurnEndTrigger, handler);
    },
};
const HealEffect = {
    activate(e) {
        for (const target of e.targets) {
            if (target === __1.TargetTypes.EnemyMonkey)
                continue;
            e.game.heal(target, e.params.value);
        }
    },
};
const HealMonkeyEffect = {
    activate(e) {
        if (!e.params.value)
            return;
        e.game.healMonkey(e.player, e.params.value);
    },
};
const ModifierEffect = {
    activate(e) {
        if (!e.params.modifier || e.params.value === undefined)
            throw new __1.InvalidEffectParamsError();
        for (const target of e.targets) {
            if (target === __1.TargetTypes.EnemyMonkey)
                continue;
            e.game.setModifier(target, e.params.modifier, e.params.value);
        }
    },
};
const SummonEffect = {
    activate(e) {
        var _a;
        if (e.player.board.length < 6) {
            if (e.params && e.params.name) {
                e.game.summon(e.player, e.params.name, e.params.count ? e.params.count : 1);
            }
            else if (e.targets) {
                for (const target of e.targets) {
                    if (target === __1.TargetTypes.EnemyMonkey)
                        continue;
                    e.game.summon(e.player, target.name, ((_a = e.params) === null || _a === void 0 ? void 0 : _a.count) ? e.params.count : 1);
                }
            }
        }
    },
};
const IncreaseCostEffect = {
    activate(e) {
        let target = e.player;
        if (e.params.player === 'OPPONENT')
            target = e.game.otherPlayer(e.player);
        if (e.params.cards === 'ALL') {
            for (const card of target.hand) {
                e.game.setPotassium(card, card.potassium + e.params.value);
            }
        }
    },
};
const DoubleHealthEffect = {
    activate(e) {
        for (const target of e.targets) {
            if (target === __1.TargetTypes.EnemyMonkey)
                continue;
            if (!target.health)
                throw new Error('Target does not have health!');
            e.game.setHealth(target, target.health * 2);
        }
    },
};
const BanosEffect = {
    activate(e) {
        const targetPlayer = e.game.otherPlayer(e.player);
        for (const card of targetPlayer.board) {
            if (Math.random() > 0.5)
                e.game.dealDamage(card, 2);
        }
    },
};
exports.Effects = {
    DamageEffect,
    BuffEffect,
    BuffForTurnEffect,
    ModifierEffect,
    SummonEffect,
    IncreaseCostEffect,
    DoubleHealthEffect,
    BanosEffect,
    HealEffect,
    HealMonkeyEffect,
};
